const mapPaymentMethod = (value) => {
    switch (value) {
        case "cod":
            return "1";
        case "bank_transfer":
            return "2";
        case "card":
            return "3";
        case "iris":
            return "4";
        default:
            return "";
    }
};

const mapCarrierType = (value) => {
    switch (value) {
        case "partnered":
            return "1";
        case "recipient_transport":
            return "2";
        case "courier":
            return "3";
        default:
            return "";
    }
};

export const buildOrderStoreFormData = ({
                                            values,
                                            subtotalWithoutVat,
                                            totalWithVat,
                                        }) => {
    const formData = new FormData();

    const payment = mapPaymentMethod(values.paymentMethod);
    const carrierType = mapCarrierType(values.deliveryMethod);
    const cashOnDelivery = payment === "1" ? "2" : "0";

    formData.append("AddressId", values.addNewAddress ? "" : (values.addressId || ""));
    formData.append("total", String(subtotalWithoutVat ?? 0));
    formData.append("vatTotal", String(totalWithVat ?? 0));
    formData.append("payment", payment);
    formData.append("cashOnDelivery", cashOnDelivery);
    formData.append("carrierType", carrierType);
    formData.append("comment", values.comment || "");

    if (values.addNewAddress) {
        formData.append("deliveryName", values.deliveryName || "");
        formData.append("fullName", values.fullName || "");
        formData.append("Address", values.street || "");
        formData.append("address2", values.address2 || "");
        formData.append("ZipCode", values.postalCode || "");
        formData.append("City", values.city || "");
        formData.append("addressLabel", values.addressLabel || "");
        formData.append("company", values.company || "");
        formData.append("AddrPhone", values.phone || "");
        formData.append("email", values.email || "");
        formData.append("CountryId", values.country || "");
        formData.append("Region",  "");
        formData.append("isInvoice",  "1");
        formData.append("Comments",  "");
    }

    if (carrierType === "1") {
        formData.append("CarrierId", values.partneredCarrierId || "");
        formData.append("storeCarrier", "0");
    }

    if (carrierType === "2") {
        const useSavedCarrier =
            values.recipientCarrierMode === "saved" && !!values.recipientCarrierId;

        formData.append("CarrierId", useSavedCarrier ? values.recipientCarrierId : "");
        formData.append("storeCarrier", values.saveRecipientCarrier ? "1" : "0");

        if (!useSavedCarrier) {
            formData.append("carrierName", values.recipientCarrierForm.companyName || "");
            formData.append("carrierAddress", values.recipientCarrierForm.address || "");
            formData.append("carrierCity", values.recipientCarrierForm.city || "");
            formData.append("carrierZipCode", values.recipientCarrierForm.zipCode || "");
            formData.append("carrierPhone", values.recipientCarrierForm.phone || "");
            formData.append("carrierEmail", values.recipientCarrierForm.email || "");
        }
    }

    if (carrierType === "3") {
        formData.append("CarrierId", "");
        formData.append("storeCarrier", "0");
    }

    return formData;
};